import React, { useEffect, useState } from "react";
import { useForm, useFieldArray } from "react-hook-form";
import ButtonWrapper from "../../../components/Button";
import { Col, Container, Row } from "react-bootstrap";
import SortingAlphabatically from "../../../reusableComponents/SortingAlphbatically";
import InputWrapper from "../../../layout/inputWrapper";
import FileUploader from "../../../reusableComponents/FileUploader2";
import ScrollButton from "../../../../../../../../core/src/pages/citizen/Home/AwasBandhu/UpwardScrollButton";
import { genderData, statesName } from "../../../../TCPForms/data";
import { shallowEqual, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { get, set } from "lodash";
import { FormControlLabel, Radio, RadioGroup } from "@material-ui/core";

const ownerEntry = {
  name: "",
  fatherOrHusbandName: "",
  mobileNumber: "",
  emailId: "",
  aadhaarNumber: "",
  gender: null,
  correspondenceAddress: {
    applicantName: null,
    applicantGuardianName: null,
    state: "",
    district: null,
    tehsil: null,
    town: null,
    address: "",
    pinno: "",
    type: "CORRESPONDENCE",
  },
  permanentAddress: {
    applicantName: null,
    applicantGuardianName: null,
    state: "",
    district: null,
    tehsil: null,
    town: null,
    address: "",
    pinno: "",
    type: "PERMANENT",
  },
};

const SubStep1 = ({
  formData,
  handleSubTabChange,
  applicationFlow,
  officesList,
  avpData,
  avpUnits,
  isEmployee,
  isApproved,
  id,
  setParams,
  initFormMTDocs,
  setShowToast,
  usersData,
}) => {
  const { documents } = useSelector((state) => state.formMT, shallowEqual);
  const [showError, setShowError] = useState(false);
  const [fastPASData, setFastPasData] = useState(null);
  const { t } = useTranslation();

  const userInfo = Digit.UserService.getUser();

  const roles = userInfo?.info?.roles || [];

  const isLtp = roles.some((role) => !["OWNER", "EMPLOYEE", "CITIZEN"].includes(role.code));

  console.log("FormData7676172617267", formData);

  const isOwner = roles.some((role) => role.code === "OWNER") && !isLtp;
  const defaultValues = {
    ...formData,

    department: applicationFlow,
    landInfo: {
      ...formData?.landInfo,
      owners: formData?.landInfo?.owners?.length > 0 ? formData?.landInfo?.owners : [ownerEntry],
    },
    documents: documents,
  };

  const { data: districtData, isLoading: isDistrictDataLoading } = Digit.Hooks.useTenants();
  // const updistricts = !isDistrictDataLoading && districtData.filter((district) => !district.code?.includes("up"));
  const updistricts = isDistrictDataLoading
    ? []
    : districtData.map((district) => ({
        label: district.name,
        value: district.name,
        name: district.name,
      }));

  const [loading, setLoading] = useState(false);
  const isDA = applicationFlow === "DA";
  const { handleSubmit, control, reset, watch, setValue, trigger, getValues } = useForm({ defaultValues });
  const { fields: owners, append: appendOwner, remove: removeOwner } = useFieldArray({
    control,
    name: "landInfo.owners",
  });
  const watchState = watch(`landInfo.owners.[0].correspondenceAddress.state`);
  const watchOffice = watch("selectedOffice") || formData?.selectedOffice;
  const watchModule = watch("selectedModule") || formData?.selectedModule;
  const watchSelectedOffice = isDA ? watchOffice?.split(" ")[0] : watchOffice?.split(",")[1]?.trim();
  const watchUnit = watch("selectedUnit") || formData?.selectedUnit;
  const watchCity = watch("selectedCity") || formData?.selectedCity;
  const filterCities = (unit, masterData) => {
    const result = masterData
      ?.filter((item) => item.Unit === unit)?.[0]
      ?.Cities?.map((item) => {
        return { name: item.City, label: item.City, value: item.City };
      });
    return result;
  };
  const avpCities = filterCities(watchUnit, avpData);

  const handleSearchClick = async (applicationNo) => {
    try {
      let response;
      let data;
      let purchasableData;
      const id = applicationNo.replace(/[-/]/g, "");
      if (applicationNo) {
        response = await Digit.OBPSService.BPAmigratedSearchappNo({ applicationNo });
        console.log(response, "responsefromId");
        if (!response?.Application?.ownerDetail) {
          setShowToast({
            key: "true",
            error: true,
            message: `No Data Found for this FASTPAS ID...!!`,
          });
          return;
        }
        data = response?.Application;
        setFastPasData(data);
        const drawingPdfs = data?.documents?.filter((e) => e.documentType === "drawingPdf");
        // setDwgPdf(drawingPdfs?.[0]?.fileStoreId);
        if (data) {
          setShowToast({
            key: "true",
            error: false,
            message: `Data fetched Successfully...!!`,
          });
        }
        //setting the owner details
        console.log(data, response, "responseee");

        setValue("landInfo.owners.[0].name", data?.ownerDetail?.ownerName);
        setValue("landInfo.owners.[0].emailId", data?.ownerDetail?.ownerEmail);
        setValue("landInfo.owners.[0].mobileNumber", data?.ownerDetail?.ownerContactNo);
        setValue("landInfo.owners.[0].correspondenceAddress.state", data?.ownerDetail?.state);
        setValue("landInfo.owners.[0].correspondenceAddress.address", data?.ownerDetail?.siteAdress);
        setValue("landInfo.owners.[0].correspondenceAddress.pinno", data?.ownerDetail?.pincode);
        const office = data?.projectDetail?.district + " " + "Development Authority";
        setValue("selectedOffice", office);

        setValue("professionalInformation.consultantCategory", data?.architectDetail?.consultantCategory);
        setValue("professionalInformation.name", data?.architectDetail?.architectName);
        setValue("professionalInformation.planDate", data?.architectDetail?.validityUpto);
        setValue("professionalInformation.mobileNumber", data?.architectDetail?.mobileNumber);
        setValue("professionalInformation.certificateNumber", data?.architectDetail?.licenseNo);
        // setValue("professionalInformation.licenseNumber",  data?.architectDetail?.licenseNo);
        setValue("professionalInformation.emailId", data?.architectDetail?.emailId);

        setValue("professionalInformation.coa", usersData?.[0]?.roles?.filter((e) => e.code !== "CITIZEN" || e.code !== "LTP")?.[0]?.name);
        setValue("professionalInformation.ername", usersData?.[0]?.name);
        setValue("professionalInformation.validupto", usersData?.[0]?.validUpto);
        setValue("professionalInformation.ermobileNumber", usersData?.[0]?.mobileNumber);
        setValue("professionalInformation.certificateNo", usersData?.[0]?.registrationArchitectNumber);
        setValue("professionalInformation.erregistrationNumber", usersData?.[0]?.registrationNumber);
        setValue("professionalInformation.eremailId", usersData?.[0]?.emailId);

        // plot information:
        setValue("descriptionOfLand.landArea", data?.plotDetail?.plotArea);
        setValue("descriptionOfLand.plotAreaDoc", data?.plotDetail?.plotAreaAsDocument);
        setValue("descriptionOfLand.developmentArea", data?.plotDetail?.developmentArea);
        setValue("descriptionOfLand.landUsesType", data?.plotDetail?.landUseZone);
        setValue("descriptionOfLand.subLandUseAsPerLayout", data?.plotDetail?.landSubUseZone);
        setValue("descriptionOfLand.landMark", data?.plotDetail?.landMark);
        setValue("descriptionOfLand.activityAsPerMap", data?.plotDetail?.plotUse);
        setValue("descriptionOfLand.activityProposed", data?.plotDetail?.plotSubUse);
        setValue("descriptionOfLand.landAddress", data?.ownerDetail?.siteAdress);

        setParams((prev) => ({
          ...prev,
          landInfo: {
            ...prev.landInfo,
            owners: [
              {
                ...prev.landInfo?.owners?.[0],
                name: data?.ownerDetail?.ownerName,
                emailId: data?.ownerDetail?.ownerEmail,
                mobileNumber: data?.ownerDetail?.ownerContactNo,
                correspondenceAddress: {
                  ...prev.landInfo?.owners?.[0]?.correspondenceAddress,
                  state: data?.ownerDetail?.state,
                  address: data?.ownerDetail?.siteAdress,
                  pinno: data?.ownerDetail?.pincode,
                },
              },
            ],
          },
          selectedOffice: watchOffice,
          professionalInformation: {
            ...prev.professionalInformation,
            name: data?.architectDetail?.architectName,
            planDate: data?.architectDetail?.validityUpto,
            mobileNumber: data?.architectDetail?.mobileNumber,
            // licenseNumber: data?.architectDetail?.licenseNo,
            emailId: data?.architectDetail?.emailId,
            certificateNumber: data?.architectDetail?.licenseNo,
            consultantCategory: data?.architectDetail?.consultantCategory,
            ername: usersData?.[0]?.name,
            validupto: usersData?.[0]?.validUpto,
            ermobileNumber: usersData?.[0]?.mobileNumber,
            erregistrationNumber: usersData?.[0]?.registrationNumber,
            eremailId: usersData?.[0]?.emailId,
            certificateNo: usersData?.[0]?.registrationArchitectNumber,
            coa: usersData?.[0]?.roles?.filter((e) => e.code !== "CITIZEN" || e.code !== "LTP")?.[0]?.name,
          },

          descriptionOfLand: {
            ...prev.descriptionOfLand,
            landArea: data?.plotDetail?.plotArea,
            plotAreaDoc: data?.plotDetail?.plotAreaAsDocument,
            developmentArea: data?.plotDetail?.developmentArea,
            landUsesType: data?.plotDetail?.landUseZone,
            subLandUseAsPerLayout: data?.plotDetail?.landSubUseZone,
            landMark: data?.plotDetail?.landMark,
            activityAsPerMap: data?.plotDetail?.plotUse,
            activityProposed: data?.plotDetail?.plotSubUse,
            landAddress: data?.ownerDetail?.siteAdress,
          },
        }));
        const mutationDocument =
          data?.documents
            ?.filter((doc) => doc?.docName === "Mutation Document")
            ?.map((doc) => {
              return {
                fileStoreId: doc?.fileStoreId,
                documentType: "mutationLetter",
                isMandatory: true,
                additionalDetails: { fileName: "mutationLetter", title: "Mutation Letter" },
              };
            }) || [];
        const registryDocument =
          data?.documents
            ?.filter(
              (doc) =>
                doc?.docName ===
                "Sale Deed/Gift deed/Will Deed any other deed/Mutation document/Lease Deed/POA/Development Agreement/Joint Venture/Consortium Agreement."
            )
            ?.map((doc) => {
              return {
                fileStoreId: doc?.fileStoreId,
                documentType: "registrySaleDeedHPTA",
                isMandatory: true,
                additionalDetails: {
                  fileName: "registrySaleDeedHPTA",
                  title:
                    "Sale Deed/Gift deed/Will Deed any other deed/Mutation document/Lease Deed/POA/Development Agreement/Joint Venture/Consortium Agreement.",
                },
              };
            }) || [];
        console.log(mutationDocument, registryDocument, "muttationDocsss");

        initFormMTDocs([...mutationDocument, ...registryDocument]);
        const isApproved = data?.descriptionOfLand?.schemeType === "Scheme";
        //setSchemeType(isApproved);
      }
    } catch (error) {
      console.error("Error occurred:", error);
    }
  };

  useEffect(() => {
    setValue("documents", documents);
  }, [documents]);
  useEffect(() => {
    setValue("landInfo.owners[0].correspondenceAddress.town", formData?.location1);
  }, [formData?.location1]);

  useEffect(() => {
    setLoading(true);
    const fetchBusinessService = async () => {
      if (isDA && watchSelectedOffice) {
        const location = watchSelectedOffice;
        const res = await Digit.LocationService.getBusinessServices(location, null, "FORM_LANDUSE", applicationFlow);
        setValue("businessService", res);
        setLoading(false);
      } else if (watchUnit && watchCity) {
        const location2 = watchCity;
        const res = await Digit.LocationService.getBusinessServices(location2, null, "FORM_LANDUSE", applicationFlow);
        setValue("businessService", res);
        setLoading(false);
      }
    };
    fetchBusinessService();
  }, [watchUnit, watchCity, watchSelectedOffice]);

  const validateFiles = () => {
    const uploadedDocs = documents?.map((doc) => doc.documentType);
    // return isValid;
    const isValid = owners?.every((_, index) => uploadedDocs?.includes(`signature_${index}`));
    console.log("Validation Result:", isValid);
    return isValid;
  };

  const validateDistinctMobileNumbers = (ownersList) => {
    const allMobileNumbers = ownersList?.map((owner) => owner.mobileNumber);
    const uniqueMobileNumbers = new Set(allMobileNumbers);
    return uniqueMobileNumbers.size === allMobileNumbers.length;
  };

  const validateDistinctAdhaarNumbers = (ownersList) => {
    const allAdhaarNumbers = ownersList?.map((owner) => owner.aadhaarNumber);
    const uniqueAdhaarNumbers = new Set(allAdhaarNumbers);
    return uniqueAdhaarNumbers.size === allAdhaarNumbers.length;
  };

  const onSubmit = (data) => {
    const ownerMobile = data.landInfo?.owners?.[0]?.mobileNumber;
    if (isLtp) {
      const isOwnerMobileSame = data.landInfo?.owners?.some((owner) => owner.mobileNumber === userInfo?.info?.mobileNumber);

      if (isOwnerMobileSame) {
        setShowToast({
          error: true,
          message: `Owner's mobile number and LTP's mobile number can't be same`,
        });
        return;
      }
    }
    if (!validateDistinctMobileNumbers(data.landInfo?.owners)) {
      setShowToast({
        error: true,
        message: `Mobile numbers must be distinct`,
      });
      return;
    }
    if (!validateDistinctAdhaarNumbers(data.landInfo?.owners)) {
      setShowToast({
        error: true,
        message: `Aadhaar numbers must be distinct`,
      });
      return;
    }
    const isValid = validateFiles();
    if (isValid) {
      data = {
        ...data,
        documents: documents,
        landInfo: {
          ...data.landInfo,
          tenantId: "up",
          address: {
            tenantId: "up",
            locality: {
              code: isDA ? watchSelectedOffice : watchCity,
            },
          },
        },
      };
      console.log("data318", data);
      handleSubTabChange(1, data);
    } else {
      setShowError(true);
      return;
    }
  };

  return (
    <section className="groupContainer3">
      <form onSubmit={handleSubmit(onSubmit)}>
        <div className="formContainer">
          <div className="formHeaderContainer">
            <h2 className="formHeading">Old Case Application No</h2>
          </div>
          <Container fluid className="formInputContainer common-app-form">
            <Row>
              <Col>
                <InputWrapper
                  control={control}
                  label="APPLICATION NO"
                  placeholder="Enter Application NO."
                  name="oldCaseApplicationNo"
                  type="textInput"
                  mandatory
                  defaultValue={formData?.oldCaseApplicationNo}
                  validation={{
                    required: {
                      value: true,
                      message: "This field is required",
                    },
                  }}
                  disabled={isEmployee}
                  showSearchIcon={true}
                  onSearchClick={() => handleSearchClick(getValues("oldCaseApplicationNo"))}
                />
              </Col>
              <Col></Col>
            </Row>
          </Container>

          <div className="formHeaderContainer">
            <h2 className="formHeading">Select Module</h2>
          </div>
          <Container fluid className="formInputContainer common-app-form">
            <Row>
              <Col>
                <InputWrapper
                  width={"98%"}
                  control={control}
                  label={"Select Module"}
                  inputLabel="Select module"
                  placeholder="Select module"
                  name="selectedModule"
                  type={"selectInput"}
                  defaultValue={formData?.selectedModule}
                  data={SortingAlphabatically([
                    { label: "Plinth", value: "Plinth" },
                    { label: "Completion", value: "Completion" },
                    { label: "Revalidation/Time Extension", value: "Revalidation/Time Extension" },
                  ])}
                  mandatory
                  validation={{
                    required: {
                      value: true,
                      message: "This field is required",
                    },
                  }}
                  disabled={formData?.selectedModule || isEmployee || isApproved || watchModule}
                />
              </Col>
            </Row>
          </Container>

          <div className="formHeaderContainer">
            <h2 className="formHeading">Verifying Authority</h2>
          </div>

          {isDA ? (
            <Container className="formInputContainer common-app-form" style={{ position: "relative", marginBottom: "10px" }} fluid>
              <Row>
                <Col>
                  <InputWrapper
                    width={"100%"}
                    control={control}
                    label={"Select Development Authority"}
                    inputLabel="Select office"
                    placeholder="Select office"
                    name="selectedOffice"
                    type={formData?.selectedOffice || isEmployee || isApproved ? "textInput" : "searchSelect"}
                    defaultValue={formData?.selectedOffice}
                    data={SortingAlphabatically(officesList)}
                    mandatory
                    validation={{
                      required: {
                        value: true,
                        message: "This field is required",
                      },
                    }}
                    disabled={formData?.selectedOffice || isEmployee || isApproved || watchOffice}
                  />
                </Col>
              </Row>
            </Container>
          ) : (
            <Container className="formInputContainer common-app-form" style={{ position: "relative", marginBottom: "10px" }} fluid>
              <Row>
                <Col>
                  <InputWrapper
                    control={control}
                    label={"Select Unit"}
                    inputLabel="Select unit"
                    placeholder="Select unit"
                    name="selectedUnit"
                    type="searchSelect"
                    data={SortingAlphabatically(avpUnits)}
                    defaultValue={formData?.selectedUnit || ""}
                    mandatory
                    validation={{
                      required: {
                        value: true,
                        message: "This field is required",
                      },
                    }}
                    disabled={isEmployee || isApproved}
                  />
                </Col>
                {watchUnit ? (
                  <Col>
                    <InputWrapper
                      control={control}
                      label={"Select City"}
                      inputLabel="Select city"
                      placeholder="Select city"
                      name="selectedCity"
                      type="searchSelect"
                      data={SortingAlphabatically(avpCities)}
                      defaultValue={formData?.selectedCity}
                      mandatory
                      validation={{
                        required: {
                          value: true,
                          message: "This field is required",
                        },
                      }}
                      disabled={isEmployee || isApproved}
                    />
                  </Col>
                ) : (
                  <Col></Col>
                )}
              </Row>
            </Container>
          )}

          {/* <div className="formHeaderContainer" style={{ marginTop: "26px" }}>
            <h2 className="formHeading">{t("Owner/Applicant Details")}</h2>
          </div> */}

          {owners &&
            owners?.map((owner, index) => (
              <React.Fragment key={owner?.id}>
                <div className="formHeaderContainer" style={{ marginTop: "26px" }}>
                  <h2 className="formHeading">{t(`Owner/Applicant ${index + 1} Details`)}</h2>
                  {index > 0 && !isEmployee && !isApproved && (
                    <div style={{ textAlign: "right", marginBottom: "10px" }}>
                      <button type="button" className="remove-owner-btn" onClick={() => removeOwner(index)}>
                        ✖ Remove Owner
                      </button>
                    </div>
                  )}
                </div>
                <Container className="formInputContainer common-app-form" fluid>
                  <Row>
                    <Col>
                      <InputWrapper
                        width={"100%"}
                        label="Name"
                        control={control}
                        placeholder="Enter Name"
                        name={`landInfo.owners.[${index}].name`}
                        type="textInput"
                        maxLength={30}
                        mandatory
                        validation={{
                          required: {
                            value: true,
                            message: "This field is required",
                          },
                          pattern: {
                            value: Digit.Utils.getPattern("Name"),
                            message: "Please enter only letters and spaces",
                          },
                        }}
                        disabled={isEmployee || isApproved}
                      />
                    </Col>
                    <Col>
                      <InputWrapper
                        width={"100%"}
                        control={control}
                        label="Father Name / Husband Name"
                        placeholder="Enter Father Name / Husband Name"
                        name={`landInfo.owners.[${index}].fatherOrHusbandName`}
                        type="textInput"
                        maxLength={30}
                        mandatory
                        validation={{
                          required: {
                            value: true,
                            message: "This field is required",
                          },
                          pattern: {
                            value: Digit.Utils.getPattern("Name"),
                            message: "Please enter only letters and spaces",
                          },
                        }}
                        disabled={isEmployee || isApproved}
                      />
                    </Col>
                  </Row>
                  <Row>
                    <Col>
                      <InputWrapper
                        width={"100%"}
                        control={control}
                        label={t("Gender")}
                        placeholder={t("Gender")}
                        name={`landInfo.owners.[${index}].gender`}
                        type="searchSelect"
                        data={SortingAlphabatically(genderData)}
                        defaultValue={formData?.landInfo?.owners?.[index]?.gender}
                        mandatory
                        validation={{
                          required: {
                            value: true,
                            message: "Please select the gender",
                          },
                        }}
                        disabled={isEmployee || isApproved}
                      />
                    </Col>
                    <Col>
                      <InputWrapper
                        width={"100%"}
                        control={control}
                        label="Mobile Number"
                        placeholder="Enter Mobile Number"
                        name={`landInfo.owners.[${index}].mobileNumber`}
                        type="number"
                        mandatory
                        validation={{
                          required: {
                            value: true,
                            message: "This field is required",
                          },
                          pattern: {
                            value: Digit.Utils.getPattern("MobileNo"),
                            message: "Please enter valid mobile no",
                          },
                        }}
                        disabled={isEmployee || isApproved}
                        maxLength={10}
                      />
                    </Col>
                  </Row>
                  <Row>
                    <Col>
                      <InputWrapper
                        width={"100%"}
                        label="E-mail ID"
                        control={control}
                        placeholder="Enter E-mail ID"
                        name={`landInfo.owners.[${index}].emailId`}
                        type="textInput"
                        mandatory
                        validation={{
                          required: {
                            value: true,
                            message: "This field is required",
                          },
                          pattern: {
                            value: Digit.Utils.getPattern("Email"),
                            message: "Please enter valid email id",
                          },
                        }}
                        disabled={isEmployee || isApproved}
                      />
                    </Col>
                    <Col>
                      <InputWrapper
                        width={"100%"}
                        label="Aadhaar Number"
                        control={control}
                        placeholder="Enter Aadhaar Number"
                        name={`landInfo.owners.[${index}].aadhaarNumber`}
                        type="number"
                        mandatory
                        validation={{
                          required: {
                            value: true,
                            message: "This field is required",
                          },
                          pattern: {
                            value: Digit.Utils.getPattern("AadharNo"),
                            message: "Please enter valid Aadhaar no",
                          },
                        }}
                        disabled={isEmployee || isApproved}
                        maxLength={12}
                      />
                    </Col>
                  </Row>
                  <Row>
                    <Col>
                      <InputWrapper
                        width={"100%"}
                        control={control}
                        label="State"
                        placeholder={"Select State"}
                        //defaultValue={owner.correspondenceAddress?.state}
                        name={`landInfo.owners.[${index}].correspondenceAddress.state`}
                        type="selectInput"
                        disabled={formData?.landInfo?.owners?.[index]?.correspondenceAddress?.state || isEmployee || isApproved}
                        data={statesName}
                        mandatory={true}
                        validation={{
                          required: {
                            value: true,
                            message: "This field is required",
                          },
                        }}
                      />
                    </Col>
                    <Col>
                      <InputWrapper
                        width={"100%"}
                        control={control}
                        data={watchState === "Uttar Pradesh" ? updistricts : undefined}
                        label={t("LABEL_DISTRICT")}
                        placeholder={watchState === "Uttar Pradesh" ? "Select District" : "Enter District"}
                        name={`landInfo.owners.[${index}].correspondenceAddress.town`}
                        type={watchState === "Uttar Pradesh" ? "searchSelect" : "textInput"}
                        mandatory
                        maxLength={25}
                        validation={{
                          required: {
                            value: true,
                            message: "This field is required",
                          },
                          pattern: {
                            value: Digit.Utils.getPattern("Name"),
                            message: "Please enter only letters and spaces",
                          },
                        }}
                        disabled={isEmployee || isApproved}
                      />
                    </Col>
                    {/* <Col>
                  <InputWrapper
                    width={"100%"}
                    control={control}
                    label="District"
                    placeholder="Enter District"
                    name={`landInfo.owners[${index}].correspondenceAddress.town`}
                    type="textInput"
                    mandatory
                    maxLength={25}
                    validation={{
                      required: {
                        value: true,
                        message: "This field is required",
                      },
                      pattern: {
                        value: Digit.Utils.getPattern("Name"),
                        message: "Please enter only letters and spaces",
                      },
                    }}
                    disabled={isEmployee || isApproved}
                  />
                </Col> */}
                  </Row>
                  <Row>
                    <Col>
                      <InputWrapper
                        width={"100%"}
                        control={control}
                        label="Communication Address"
                        placeholder="Enter Communication Address"
                        name={`landInfo.owners.[${index}].correspondenceAddress.address`}
                        type="textInput"
                        mandatory
                        maxLength={150}
                        validation={{
                          required: {
                            value: true,
                            message: "This field is required",
                          },
                          // pattern: {
                          //   value: Digit.Utils.getPattern("Address"),
                          //   message: "Please enter valid Address",
                          // },
                        }}
                        disabled={isEmployee || isApproved}
                      />
                    </Col>
                    <Col>
                      <InputWrapper
                        width={"100%"}
                        control={control}
                        label="Pin Code"
                        placeholder="Enter Pin Code"
                        name={`landInfo.owners.[${index}].correspondenceAddress.pinno`}
                        type="number"
                        mandatory
                        validation={{
                          required: {
                            value: true,
                            message: "This field is required",
                          },
                          pattern: {
                            value: Digit.Utils.getPattern("Pincode"),
                            message: "Please enter valid Pin Code",
                          },
                        }}
                        maxLength={6}
                        disabled={isEmployee || isApproved}
                      />
                    </Col>
                  </Row>
                  <Row>
                    <Col>
                      <div className="custom-upload new-custom-uploader signature-attach-uploader">
                        {!isEmployee && !isApproved && (
                          <FileUploader
                            control={control}
                            name={`signature_${index}`}
                            label="Attach Signature"
                            validationMsg="(jpg, jpeg, png file only and Max file Size 10 MB)"
                            isMandatory
                            required
                            tab={2}
                            maxFiles={1}
                            showError={showError}
                          />
                        )}
                      </div>
                    </Col>
                    <Col>
                      {!isEmployee && !isApproved && (
                        <button
                          type="button"
                          className="add-owner-btn"
                          // onClick={() => appendOwner(ownerEntry)}
                          onClick={() =>
                            appendOwner({
                              ...ownerEntry,

                              // Fill only for OWNER users
                              mobileNumber: isOwner ? formData?.professionalInformation?.mobileNumber || "" : "",
                            })
                          }
                          style={{ marginTop: "40px" }}
                        >
                          + Add Owner
                        </button>
                      )}
                    </Col>
                  </Row>
                  <br />
                </Container>
              </React.Fragment>
            ))}

          <div className="footerContainer2">
            <div className="buttonWrapper">
              {!isEmployee && !isApproved && (
                <ButtonWrapper
                  variant="contained"
                  color="success"
                  size="medium"
                  label={"Save"}
                  type="submit"
                  disabled={loading}
                  sx={{ backgroundColor: "black", marginRight: "4px", marginTop: "20px" }}
                />
              )}
            </div>
            <ScrollButton />
          </div>
        </div>
      </form>
    </section>
  );
};

export default SubStep1;
